// src/components/wizard/WizardWho.jsx
import React from 'react';
import styles from './WizardStep.module.css';

const OPTIONS = [
  { value:'veteran',  icon:'🎖', label:'A Veteran',          desc:'Released from CAF, RCMP, or other service' },
  { value:'caf',      icon:'🛡', label:'Serving CAF member',  desc:'Currently in the Canadian Armed Forces' },
  { value:'rcmp',     icon:'⚖️', label:'RCMP member',         desc:'Serving or retired RCMP officer' },
  { value:'spouse',   icon:'🤝', label:'Spouse or partner',   desc:'Partner of a Veteran or serving member' },
  { value:'family',   icon:'👨‍👩‍👧', label:'Family member',       desc:'Child, parent, sibling, or caregiver' },
  { value:'provider', icon:'🩺', label:'Service provider',    desc:'Clinician, case manager, or support worker' },
];

export default function WizardWho({ selected, onToggle, canContinue, onBack, onNext, onSkip }) {
  return (
    <div className={styles.stepWrap}>
      <p className={styles.eyebrow}>Let's personalise your results</p>
      <h1 className={styles.title}>Who are you looking<br />for support <em>for?</em></h1>
      <p className={styles.subSm}>Select all that apply — this helps us surface the most relevant programs.</p>
      <p className={styles.multiHint}>You can select more than one</p>

      <div className={`${styles.optGrid} ${styles.optGrid2}`} style={{ maxWidth: 580 }}>
        {OPTIONS.map(o => (
          <button
            key={o.value}
            className={`${styles.optCard} ${selected.includes(o.value) ? styles.selected : ''}`}
            onClick={() => onToggle(o.value)}
          >
            <div className={styles.optIcon}>{o.icon}</div>
            <div>
              <div className={styles.optLabel}>{o.label}</div>
              <div className={styles.optDesc}>{o.desc}</div>
            </div>
          </button>
        ))}
      </div>

      <div className={styles.btnRow}>
        <button className={styles.btnBack} onClick={onBack}>← Back</button>
        <button className={styles.btnNext} onClick={onNext} disabled={!canContinue}>Continue →</button>
        <button className={styles.btnText} onClick={onSkip}>Skip all</button>
      </div>
    </div>
  );
}
